import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Unit } from '../../../../../../api/Engrain';
import { MapUnitColorDto, MapUnitDto } from '../../../../../../api/UnitMap';
import Button from '../../../../../common/form/Button';
import FormSelectLabeled from '../../../../../common/form/SelectLabeled';

interface Props {
    unit: MapUnitDto;
    onUnitChanged: (newConfig?: MapUnitDto) => void;
    unitList?: Unit[];
    unitColors: MapUnitColorDto[];
}

const UnitColorConfiguration = (props: Props) => (
    <>
        {props.unitList && (
            <Container className="stop-configuration">
                <Row className="justify-content-center">
                    <Col xs={10}>
                        <FormSelectLabeled
                            labelProps={{
                                labelText: 'Select Unit',
                                invalidText: undefined
                            }}
                            selectProps={{
                                id: 'unit-id',
                                name: 'unitId',
                                required: true,
                                value: props.unit.unitId,
                                disabled: false,
                                clearable: false,
                                searchable: true
                            }}
                            selectOptions={props.unitList
                                .map(u => {
                                    return {
                                        value: u.id,
                                        label: u.name
                                    };
                                })
                                .sort((a, b) => {
                                    if (a.label < b.label) {
                                        return -1;
                                    }
                                    if (a.label > b.label) {
                                        return 1;
                                    }
                                    return 0;
                                })}
                            onChange={(_name, value) => {
                                return (
                                    value &&
                                    props.onUnitChanged({
                                        ...props.unit,
                                        unitId: value.toString()
                                    })
                                );
                            }}
                        />
                    </Col>
                    <Col xs={2} className="justify-content-center">
                        <Button
                            text="Delete"
                            onClick={() => {
                                props.onUnitChanged();
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <FormSelectLabeled
                            labelProps={{
                                labelText: 'Select Color',
                                invalidText: undefined
                            }}
                            selectProps={{
                                id: 'unit-color',
                                name: 'unitColor',
                                required: true,
                                value: props.unit.unitColor.id,
                                disabled: false,
                                clearable: false,
                                searchable: true
                            }}
                            selectOptions={props.unitColors.map(c => {
                                return {
                                    value: c.id,
                                    label: c.label
                                };
                            })}
                            onChange={(_name, value) => {
                                let color = props.unitColors.find(c => c.id === (value as number));
                                return (
                                    value &&
                                    color &&
                                    props.onUnitChanged({
                                        ...props.unit,
                                        unitColor: color,
                                        unitColorId: color.id
                                    })
                                );
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        )}
    </>
);

export default UnitColorConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/unitMapControls/UnitColorConfiguration.tsx